import React, { useState } from 'react';

import { DangerButton, InfoButton } from '@magoosh/lib/button';
import { Select } from '@magoosh/lib/forms';
import { adminPaths } from 'config/path_helpers';
import fetch from 'utilities/fetch';

import { PromptRequest } from '../../types';

interface Props {
  onComplete: (promptRequest: PromptRequest) => void;
  promptRequest: PromptRequest;
}

const Actions: React.FC<Props> = (props) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [accessLevel, setAccessLevel] = useState(null);

  const accept = () => {
    setIsSubmitting(true);

    fetch(adminPaths.api.testPrep.aiPromptRequestAccept(props.promptRequest.id), {
      method: 'POST',
      body: JSON.stringify({ accessLevel })
    }).then((response) => {
      setIsSubmitting(false);
      props.onComplete(response.promptRequest);
    }).catch((error) => {
      alert(error.errors);
      setIsSubmitting(false);
    });
  };

  const reject = () => {
    setIsSubmitting(true);

    fetch(adminPaths.api.testPrep.aiPromptRequestReject(props.promptRequest.id), {
      method: 'POST'
    }).then((response) => {
      setIsSubmitting(false);
      props.onComplete(response.promptRequest);
    }).catch((error) => {
      alert(error.errors);
      setIsSubmitting(false);
    });
  };

  return (
    <div className="align-items-center d-flex gap-s">
      <Select
        groupClassName="u-margin-A-n"
        onChange={(e) => setAccessLevel(e.target.value)}
        value={accessLevel}
      >
        <option>Access Level</option>
        <option value={0}>Free</option>
        <option value={25}>Trial</option>
        <option value={60}>Premium</option>
        <option value={100}>Draft</option>
      </Select>

      <DangerButton onClick={reject} submitting={isSubmitting}>Reject</DangerButton>
      <InfoButton onClick={accept} submitting={isSubmitting}>Create Prompts</InfoButton>
    </div>
  );
};

export default Actions;
